<template>
    <div class="detail">
        <div class="bg-gray-400 px-24 py-12">
            <a id="botao-voltar" @click.prevent="back()" class="cursor-pointer hover:bg-gray-400 bg-gray-200 shadow-lg px-6 py-4">
                <i class="fas fa-chevron-left"></i>
                <span class="ml-2 text-sm font-bold uppercase">Voltar</span>
            </a>
            <div id="not-found" class="mt-10" v-if="not_found">
                <div class="p-6 bg-yellow-200 text-yellow-800 rounded flex items-center">
                    <i class="fas fa-2x fa-bell mr-3"></i>
                    <p class="text-xl">API não encontrada</p>
                </div>
            </div>
            <div class="p-8 flex items-center" v-else>
                <img id="profile" class="bg-gray-900 w-32 h-32 rounded-full shadow-lg flex-shrink-0" :src="api.pic"/>
                <div class="ml-8 w-full h-32">
                    <div class="flex items-baseline mb-5">
                        <skeleton-box class="h-12" v-bind:loading="loading">
                            <h2 class="text-4xl text-accent font-bold tracking-tight" v-text="api.nome"></h2>
                        </skeleton-box>
                        <skeleton-box class="ml-3 w-1/6" v-bind:loading="loading">
                            <div class="versao text-gray-600 text-sm" v-text="api.versao"></div>
                        </skeleton-box>
                    </div>
                    <div class="mb-2">
                        <skeleton-box class="w-full mb-1" v-bind:loading="loading">
                            <p class="text-gray-600" v-text="api.descricao"></p>
                        </skeleton-box>
                        <skeleton-box class="w-full mb-1" v-bind:loading="loading"></skeleton-box>
                        <skeleton-box class="w-full" v-bind:loading="loading"></skeleton-box>
                    </div>
                    <div class="tags">
                        <skeleton-box class="w-2/5" v-bind:loading="loading">
                            <span class="rounded px-3 py-1 mr-3 text-sm uppercase text-white bg-blue-500"
                                  v-bind:key="tag" v-for="tag in api.tags"
                                  v-text="tag">&nbsp;</span>
                        </skeleton-box>
                    </div>
                </div>
            </div>
        </div>
        <div class="bg-gray-200 px-24 py-12" v-if="!not_found && api.id">
            <tabs>
                <tab title="Sobre" :selected="true">
                    <div v-html="api.sobre"></div>
                </tab>
                <tab title="Documentação">
                    <div v-html="api.documentacao"></div>
                </tab>
                <tab title="Suporte">
                    <div v-html="api.suporte"></div>
                </tab>
            </tabs>
            <button class="mt-8 bg-accent text-gray-900 font-bold py-4 px-24 shadow hover:bg-accent-lighter uppercase">
                assine
            </button>
        </div>
    </div>
</template>
<script>
    import axios from "axios";
    import SkeletonBox from "../components/SkeletonBox";
    import Tabs from "../components/Tabs";
    import Tab from "../components/Tab";

    export default {
        name: 'Detail',
        components: {SkeletonBox, Tabs, Tab},
        mounted() {
            const api_id = this.$route.params.id
            this.loading = true
            axios.get('/api/apis/' + api_id)
                .then(response => {
                    this.api = response.data
                    if(!this.api.id) {
                        this.not_found = true;
                    }
                })
                .then(() => this.loading = false)
        },
        data() {
            return {
                not_found: false,
                loading: false,
                api: {}
            }
        },
        methods: {
            back() {
                this.$router.go(-1)
            }
        }
    }
</script>